import React from 'react';
import ProductInfo from '../../components/productmng/ProductInfo';

const ProductInfoContainer = ({product}) => {
  return <ProductInfo product={product}/>
};

export default ProductInfoContainer;
